<template>
    <template v-if="show">
        <slot name="main" :text="text">
            <component :is="element"
                :id="value.id"
                :class="value.class"
                :style="value.style"
                :src="value.src"
                :href="value.href"
                :target="value.target"
                :disabled="$evaluate.eval(value.disabled)"
                @click.stop="(create && setUpdate()) || (edit && value.onclick && click(value.onclick))"
            >
                <slot name="text">
                    <span v-if="text !== null">{{ format(text) }}</span>
                </slot>
                <slot name="units">
                    <span v-if="value.units" class="ms-1">{{ value.units }}</span>
                </slot>
                <template v-if="element == 'table'">
                    <tbody>
                        <Structure v-model="value" :edit="edit" :create="create"/>
                    </tbody>
                </template>
                <template v-else>
                    <Structure v-model="value" :edit="edit" :create="create"/>
                </template>
            </component>
        </slot>
    </template>
</template>

<script>
import { defineAsyncComponent } from 'vue';
const Structure = defineAsyncComponent(() => import('@/components/Structure.vue'));
import CreateComponent from '@/components/calculations/CreateComponent.vue';

export default {
    components: {
        Structure,
        CreateComponent
    },
    props: {
        modelValue: {},
        element: {
            type: String
        },
        edit: {
            type: Boolean,
            required: false,
            default: false
        },
        create: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {}
    },
    computed: {
        text: function(){
            if (this.value.calculate) {
                var value = this.$evaluate.eval(this.value.calculate);
                if (value !== null) {
                    return value;
                }
                else {
                    return this.$t("calculation.evaluating");
                }
            }
            else {
                if (this.value.text) {
                    return this.value.text;
                }
                else {
                    return this.value.value;
                }
            }
        },
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
        show: function () {
            return this.value && !this.$evaluate.eval(this.value.hide);
        },
    },
    methods: {
        update: function (data) {
            this.value = data;
        },
        setUpdate: function () {
            this.$store.commit("updateComponent", {
                function: this.update,
                data: this.value
            });
        },
        format: function (value) {
            if (this.value.format) {
                return new Intl.NumberFormat().format(value);
            }
            return value;
        },
        click: function(str){
            console.log(eval(str))
        }
    }
}
</script>
<style lang="scss">
</style>